import * as React from 'react';
import { BaSeStaticAsset } from '../static-asset/static-asset';
import { ImageProps } from './image-props';
import { numberWithUnit } from '../../utils/string-utils';

export interface IllustrationProps extends Omit<ImageProps, 'size'> {
  colorSchema?: 'mono' | 'multi';
}

export const BaSeIllustration: React.FC<IllustrationProps> = ({
  name,
  description,
  width,
  height,
  color,
  colorTransition,
  colorSchema = 'mono',
  onClick,
}) => {
  if (colorSchema === 'multi') {
    throw Error(
      '[BaSeIllustration] "colowSchema = multi" ainda não implementado',
    );
  }

  return (
    <BaSeStaticAsset
      classIdentifier="BaSe--illustration"
      width={width ? numberWithUnit(width) : undefined}
      height={height ? numberWithUnit(height) : undefined}
      description={description}
      path={`images/illustrations/static/${colorSchema}-color/${name}.svg`}
      color={color}
      colorTransition={colorTransition}
      onClick={onClick}
    />
  );
};

BaSeIllustration.displayName = 'BaSeIllustration';
